(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-fit-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-fit-panel')) {
    const STORAGE_KEY = 'pdp-fit-unit';

    const readUnit = () => {
      try {
        return localStorage.getItem(STORAGE_KEY) === 'cm' ? 'cm' : 'in';
      } catch (error) {
        return 'in';
      }
    };

    const toUnit = (value, unit) => {
      if (unit !== 'cm') return value;
      return value.replace(/\d+(?:\.\d+)?/g, (number) => String(Math.round(parseFloat(number) * 2.54)));
    };

    class PdpFitPanel extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-component') || document;
        this.unit = readUnit();
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.scope.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.renderUnits();
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
      }

      onChange(event) {
        const target = event.target;
        const optionName = (this.dataset.optionName || '').toLowerCase();
        if (target instanceof HTMLInputElement && target.checked) {
          if ((target.dataset.optionName || '').toLowerCase() === optionName) this.showSize(target.value);
        } else if (target instanceof HTMLSelectElement) {
          const label = target.closest('.variant-option')?.querySelector('label');
          if (label && label.textContent.trim().toLowerCase() === optionName) this.showSize(target.value);
        }
      }

      onClick(event) {
        const button = event.target instanceof Element ? event.target.closest('[data-unit]') : null;
        if (!button || !this.contains(button)) return;
        this.unit = button.dataset.unit === 'cm' ? 'cm' : 'in';
        try {
          localStorage.setItem(STORAGE_KEY, this.unit);
        } catch (error) {
          /* storage unavailable */
        }
        this.renderUnits();
      }

      showSize(size) {
        const rows = this.querySelectorAll('tr[data-size]');
        let match = null;
        rows.forEach((row) => {
          const isMatch = row.dataset.size === size;
          row.classList.toggle('is-selected', isMatch);
          if (isMatch) match = row;
        });

        const list = this.querySelector('.pdp-fit__rows');
        if (!list) return;
        list.hidden = !match;
        if (!match) return;

        list.querySelectorAll('[data-column]').forEach((value) => {
          const cell = match.querySelector(`[data-column="${value.dataset.column}"]`);
          value.dataset.in = cell ? cell.dataset.in : '';
        });
        this.renderUnits();
      }

      renderUnits() {
        this.querySelectorAll('[data-unit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.unit === this.unit));
        });
        this.querySelectorAll('.pdp-fit__value').forEach((value) => {
          value.textContent = toUnit(value.dataset.in || '', this.unit);
        });
        this.querySelectorAll('.pdp-fit__suffix').forEach((suffix) => {
          suffix.textContent = this.unit;
        });
      }
    }

    customElements.define('pdp-fit-panel', PdpFitPanel);
  }
  } catch(e) { console.error(e); }
})();

})();
